import { PaymentMethodType } from 'payment-methods/domain/payment-method';
import { PolicyholderEntityType } from 'policyholder/domain/policyholder';
import { IdentificationType } from 'policyholder/domain/policyholder-identification';
import { Construct } from '../../models/construct';
import { PolicyBillingFrequency } from '../../policies/domain/policy-billing';
import { snakeToCamel } from '../../utils';

// These enums should find a better home, they dont belong here

export enum Currency {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BOV = 'BOV',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHE = 'CHE',
  CHF = 'CHF',
  CHW = 'CHW',
  CLF = 'CLF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  COU = 'COU',
  CRC = 'CRC',
  CUC = 'CUC',
  CUP = 'CUP',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  FJD = 'FJD',
  FKP = 'FKP',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRU = 'MRU',
  MUR = 'MUR',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MXV = 'MXV',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SLE = 'SLE',
  SOS = 'SOS',
  SRD = 'SRD',
  SSP = 'SSP',
  STN = 'STN',
  SVC = 'SVC',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  USN = 'USN',
  UYI = 'UYI',
  UYU = 'UYU',
  UYW = 'UYW',
  UZS = 'UZS',
  VED = 'VED',
  VES = 'VES',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  XAF = 'XAF',
  XAG = 'XAG',
  XAU = 'XAU',
  XBA = 'XBA',
  XBB = 'XBB',
  XBC = 'XBC',
  XBD = 'XBD',
  XCD = 'XCD',
  XDR = 'XDR',
  XOF = 'XOF',
  XPD = 'XPD',
  XPF = 'XPF',
  XPT = 'XPT',
  XSU = 'XSU',
  XTS = 'XTS',
  XUA = 'XUA',
  XXX = 'XXX',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMW = 'ZMW',
  ZWL = 'ZWL',
}

export enum PolicySchemeType {
  Individual = 'individual',
  Group = 'group',
}

export enum GracePeriodOptions {
  ConsecutiveSkippedPayments = 'consecutive_skipped_payments',
  SkippedPaymentsOverPolicyTerm = 'skipped_payments_over_policy_term',
  SkippedPaymentsWithinPeriod = 'skipped_payments_within_period',
  PeriodAfterMissedPayment = 'period_after_missed_payment',
  NoSuccessfulMonthlyPremiumPayments = 'no_successful_monthly_premium_payments',
  NoMonthlyPremiumPayments = 'no_monthly_premium_payments',
}

export enum GracePeriodNotificationTriggers {
  BeforeTheGracePeriodExpires = 'before_the_grace_period_expires',
  OnTheGracePeriodExpiryDate = 'on_the_grace_period_expiry_date',
}

export enum WaitingPeriodNotificationTriggers {
  OnTheWaitingPeriodExpiryDate = 'on_the_waiting_period_expiry_date',
  BeforeTheWaitingPeriodExpires = 'before_the_waiting_period_expires',
}

export enum CoolingOffPeriodOptions {
  AllPremiums = 'all_premiums',
  None = 'none',
}

export enum PeriodOf {
  Days = 'days',
  Months = 'months',
}

export enum ApplyRulesTo {
  Policy = 'the_full_policy',
}

export interface GracePeriodPeriodConfig {
  rules: [
    {
      lapseAfter: GracePeriodOptions;
      skippedPayments?: number;
      period: {
        type: PeriodOf;
        value: number;
      };
    },
  ];
  notifications?: [
    {
      trigger: GracePeriodNotificationTriggers;
      period: {
        type: PeriodOf;
        value: number;
      };
    },
  ];
}

export interface CoolingOffPeriodConfig {
  rules: [
    {
      applyTo: ApplyRulesTo;
      period: {
        type: PeriodOf;
        value: number;
      };
      refundType: CoolingOffPeriodOptions;
    },
  ];
}

export interface CoolingOffPeriodRule {
  applyTo: ApplyRulesTo;
  period: {
    type: PeriodOf;
    value: number;
  };
  refundType: CoolingOffPeriodOptions;
}

export interface WaitingPeriodConfig {
  rules: [
    {
      applyTo: ApplyRulesTo;
      period: {
        type: PeriodOf;
        value: number;
      };
    },
  ];
  notifications?: [
    {
      trigger: WaitingPeriodNotificationTriggers;
      period: {
        type: PeriodOf;
        value: number;
      };
    },
  ];
}

export interface DocumentLabelListItems {
  label: string;
  required: boolean;
}

interface FulfillmentType {
  key: string;
  label: string;
  fulfillmentData: {
    [key: string]: {
      label: string;
      valueType: string | number | 'enum';
      valueOptions?: { [key: string]: string };
    };
  };
}

export interface IndividualPolicyholderFields {
  dateOfBirth?: {
    required: boolean;
    hidden?: boolean;
  };
  address?: {
    suburb?: {
      required: boolean;
    };
  };
  gender?: {
    hidden?: boolean;
  };
  email?: {
    required?: boolean;
  };
}

export interface CollectionModuleBillingSetting {
  key: string;
}

export class ProductModuleDefinitionSettings {
  readonly canIssuePolicyThroughDashboard: boolean;
  readonly policySchemeType: PolicySchemeType;
  readonly canUpdateSumAssured: boolean;
  readonly policyholder: {
    entityTypes: PolicyholderEntityType[];
    idTypes: IdentificationType[];
    idCountry?: string;
    customIdName?: string;
    individualPolicyholderFields?: IndividualPolicyholderFields;
  };
  readonly beneficiaries: {
    enabled: boolean;
    min: number;
    max: number;
    policyholderIsBeneficiary: boolean;
    individualBeneficiaryFields?: {
      dateOfBirth?: {
        required: boolean;
      };
      address: {
        displayAddress: boolean;
      };
    };
  };
  readonly coveredItems?: {
    enabled: boolean;
    maxSumAssured: number;
  };
  readonly coveredPeople?: {
    enabled: boolean;
    min: number;
    max: number;
  };
  readonly billing: {
    paymentMethodTypes: PaymentMethodType[];
    currency: Currency;
    premiumType: PolicyBillingFrequency;
    paymentReference: string;
    proRataBillingOnIssue: boolean;
    proRataBillingDisabled?: boolean;
    proRataMinimum: number;
    retries: {
      retryFailedPayments: number;
      daysBetweenFailedPaymentRetries: number;
    };
    billBeforeWeekend: boolean;
    naedoArrearsPolicies: boolean;
    collectionModules?: CollectionModuleBillingSetting[];
  };
  readonly lifecycle: {
    canRequote?: boolean;
    canReactivate?: boolean;
    activateOnIssue: boolean;
    coolingOffPeriod: CoolingOffPeriodConfig;
    gracePeriod: GracePeriodPeriodConfig;
    waitingPeriod: WaitingPeriodConfig;
  };
  readonly claims: {
    claimChecklistItems: string[];
    fulfillmentTypes?: FulfillmentType[];
  };
  readonly documents?: {
    documentLabelListItems: DocumentLabelListItems[];
  };

  constructor(init: Construct<ProductModuleDefinitionSettings>) {
    Object.assign(this, init);
  }

  static fromNetwork(init: any) {
    return new ProductModuleDefinitionSettings({
      ...snakeToCamel(init), // TODO - do this properly with an network interface
    });
  }
}
